import { parseJSON } from 'date-fns';
import { z } from 'zod';

export const engagementFeedSchema = z.object({
  type: z.literal('engagementFeed'),
  data: z.array(
    z.object({
      resource: z.object({
        id: z.string().optional(),
        name: z.string().optional().nullable(),
        image: z.string().nullable().optional(),
        type: z.string().optional().nullable(),
        familyId: z.string().nullable().optional(),
      }),
      studentsViewed: z.number().int(),
      timeEngaged: z.number().int(),
      annotations: z.number().int(),
      avgQuizScore: z.number().nullable(),
      date: z.string().transform<Date>((v) => parseJSON(v)),
    })
  ),
});

export type EngagementFeedResponse = z.infer<typeof engagementFeedSchema>;
